<template>
    <div class="emoji-panel iphone-x-fit"
        v-if="isShow">
        <div class="emoji">
            <swiper :options="swiperOptions">
                <swiper-slide
                    class="swiper__item"
                    v-for="(emojiGroup, groupIndex) in emojiGroupList"
                    :key="groupIndex">
                    <div class="swiper__inner">
                        <div class="emoji__list">
                            <div class="emoji__item"
                                v-for="(item, index) in emojiGroup"
                                :key="index"
                                @click="addEmoji(item)">
                                <img
                                    class="swiper-lazy"
                                    :data-src="item.uri" />
                            </div>
                            <div class="emoji__item delete"
                                @click="deleteContent"></div>
                        </div>
                    </div>
                </swiper-slide>
                <div
                    class="swiper__pagination"
                    slot="pagination"></div>
            </swiper>
        </div>
    </div>
</template>

<script>
    import { emoji } from './data'
    import { paging } from '@/utils'

    const PAGE_SIZE_OF_MOBILE = 20
    const PAGE_SIZE_OF_DESKTOP = 50

    export default {
        name: 'TheEmojiPanel',
        props: {
            isShow: {
                type: Boolean,
                required: true
            },
            typingContent: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                swiperOptions: {
                    pagination: {
                        el: '.swiper__pagination',
                        clickable: true
                    },
                    lazy: {
                        loadPrevNext: true
                    }
                }
            }
        },
        computed: {
            pageSize () {
                return this.$eventBus.isDesktop
                    ? PAGE_SIZE_OF_DESKTOP
                    : PAGE_SIZE_OF_MOBILE
            },
            pageCount () {
                return emoji.length / this.pageSize
            },
            emojiGroupList () {
                const result = []
                for (let i = 0; i < this.pageCount; i++) {
                    result.push(paging(emoji, i, this.pageSize))
                }
                return result
            }
        },
        methods: {
            addEmoji ({ uri, sign, code }) {
                const typingInput = this.$parent.$refs.chatInputTyping
                const img = new Image()
                img.src = uri
                img.title = sign
                img.setAttribute('code', code)
                img.setAttribute('class', 'emoji-icon')

                typingInput.appendChild(img)
                typingInput.scrollTop = typingInput.scrollHeight

                this.$emit('update:typingContent', typingInput.innerHTML)
            },
            // 可删除 emoji 和 输入文本
            deleteContent () {
                const typingInput = this.$parent.$refs.chatInputTyping
                const removeRegex = /(<img[^>]+>$|&nbsp;$|<br>$)/gi
                const matchStr = this.typingContent.match(removeRegex)
                let newTypingContent = ''

                if (matchStr) {
                    newTypingContent = this.typingContent.slice(0, -matchStr[0].length)
                } else {
                    newTypingContent = this.typingContent.slice(0, -1)
                }

                typingInput.innerHTML = newTypingContent

                this.$emit('update:typingContent', newTypingContent)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .emoji-panel {
        background-color: #FAFBFD;
        border-top: 1px solid #F4F4F6;

        @include desktop {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 100%;
            box-shadow: 0 -5px 5px rgba(0, 0, 0, 0.05);
        }
    }

    .swiper {
        /* &__item {

        } */

        &__inner {
            padding: 0 percent(22) 20px;
        }

        &__pagination {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 11px;
            height: 6px;
            font-size: 0;
            text-align: center;
            z-index: 10;
        }
    }

    .emoji {
        position: relative;

        /* &__list {

        } */

        &__item {
            $emojiListWidth: 375 - 22 * 2;
            display: inline-block;
            width: percent(30, $emojiListWidth);
            padding-bottom: percent(30, $emojiListWidth);
            height: 0;
            margin: percent(8, $emojiListWidth);
            vertical-align: top;
            cursor: pointer;

            img {
                width: 100%;
            }

            @include desktop {
                width: 24px;
                padding-bottom: 24px;
                margin: 8px;
            }
        }
    }

    .delete {
        background: url("./img/remove.png") 50% 50% no-repeat;
        background-size: cover;
    }
</style>
